import gql from "graphql-tag";

export const CustomTenantInfoAdminLocationGroups = gql`
  query getBizTenantInfoAdmin($langCd: String!) {
    getBizTenantInfoAdmin(langCd: $langCd) {
      id
      code
      lang_cd
      current_lang_cd
      name
      location_groups {
        id
        tenant_id
        name
        position
        display_name
        is_default
        is_show_chat_history
        color
        locations {
          id
          location_group_id
          name_dict
          qr
          default_name
          is_default_location
          is_room_asking
          name
          hash_value
          pms_name
          cms_flag
        }
        main_menus {
          id
          location_group_id
          main_menu_id
          order_no
          sub_menus {
            id
            location_main_menu_id
            sub_menu_id
            order_no
          }
        }
      }
    }
  }
`;
